import type { ComponentPropsWithoutRef } from 'react';

interface SlideProps extends ComponentPropsWithoutRef<'div'> {
   show: boolean | undefined | null;
}

export function Slide({ show = false, style, children, ...otherProps }: SlideProps) {
   return (
      <div
         style={{
            ...style,
            transition: 'transform 0.2s ease-in-out',
            transform: show ? 'translateY(0)' : 'translateY(100%)',
         }}
         {...otherProps}
      >
         {children}
      </div>
   );
}
